let lenisInstance = null;

export function getLenis() {
    return lenisInstance;
}

export function setLenis(instance) {
    lenisInstance = instance;
}

export function scrollTo(target, options = {}) {
    const { onComplete, offset = 0, ...rest } = options;
    if (lenisInstance) {
        lenisInstance.scrollTo(target, {
            duration: 1.4,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            offset,
            ...rest,
            onComplete: () => { if (onComplete) onComplete() },
        });
    } else {
        if (typeof target === 'number') {
            window.scrollTo({ top: target + offset, behavior: 'smooth' });
        } else if (typeof target === 'string') {
            const el = document.querySelector(target);
            if (el) {
                const elementPosition = el.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({ top: elementPosition + offset, behavior: 'smooth' });
            }
        } else if (target?.getBoundingClientRect) {
            const elementPosition = target.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({ top: elementPosition + offset, behavior: 'smooth' });
        }
        if (onComplete) setTimeout(onComplete, 400);
    }
}
